export default __webpack_public_path__ + "static/media/CT_AT&T.f3bb789f.png";